<template>
  <CommonPages id="detail" :class="['detail']" :titlePrefix="bookInfo.title || 'Detail'"
    :metaDescription="bookInfo.summary || domainConfig?.['meta']?.des">

    <div class="detail-container">
      <AdComponent v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.detail_1"
        ref="ads-detail-1" class=" m_padding" :ads="adsensConfig?.detail_1"
        :showDebug="showDebug" />

      <div class="detail-main-layout"
        :class="{'detail-main-layout--mobile': deviceType === 'mobile'}">
        <!-- 左侧内容区域 (PC) / 中间内容区域 (Mobile) -->
        <div class="detail-content-left">
          <AdComponent v-if="deviceType === 'mobile'"
            v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.detail_2"
            ref="ads-detail-2-mobile" class="m_padding" :ads="adsensConfig?.detail_2"
            :showDebug="showDebug" />

          <!-- 摘要部分 -->
          <div class="detail__section detail__summary">
            <h2 class="detail__section-title">Summary</h2>
            <p class="detail__summary-content">
              <template v-if="!loading">{{ bookInfo.summary }}</template>
            </p>
          </div>

          <!-- 标签部分 -->
          <div class="detail__section detail__tags"
            v-if="!loading && bookInfo.tags && bookInfo.tags.length > 0">
            <h2 class="detail__section-title">Tags</h2>
            <div class="detail__tags-list">
              <div v-for="(tag, index) in bookInfo.tags" :key="index" class="detail__tags-item"
                @click="navigateToTag(tag)">
                {{ tag }}
              </div>
            </div>
          </div>

          <!-- 章节列表 -->
          <div class="detail__section detail__chapters">
            <div class="detail__chapters-header">
              <h2 class="detail__section-title">Chapters</h2>
            </div>
            <div class="detail__chapters-list" :class="{'skeleton-container': loading}">
              <template v-for="(chapter, index) in displayedChapters">
                <a :key="chapter.id" @click="goToChapter(chapter)" class="detail__chapter-item">
                  <div class="chapter-item__number-wrapper">
                    <div class="chapter-item__number">{{ String(chapter.number).padStart(2, '0') }}
                    </div>
                  </div>
                  <div class="chapter-item__title">{{ chapter.title }}</div>
                </a>
                <AdComponent v-if="deviceType == 'mobile' && index == 7"
                  v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.detail_3"
                  ref="ads-detail-3" class="" :ads="adsensConfig?.detail_3"
                  :showDebug="showDebug" />
              </template>
            </div>

            <!-- 章节分页 -->
            <div class="category-pagination" v-if="chapterTotalPages > 1">
              <img src="@/assets/vector-left.svg" alt="Previous" @click="prevChapterPage"
                :class="{'disabled': chapterPage === 1}" class="category-pagination__arrow">
              <div class="category-pagination__dots">
                <span v-for="page in chapterTotalPages" :key="page" class="category-pagination__dot"
                  :class="{'active': page === chapterPage}" @click="goToChapterPage(page)"></span>
              </div>
              <img src="@/assets/vector-right.svg" alt="Next" @click="nextChapterPage"
                :class="{'disabled': chapterPage === chapterTotalPages}"
                class="category-pagination__arrow">
            </div>
          </div>
        </div>

        <!-- 右侧书籍卡片 (PC) / 顶部书籍卡片 (Mobile) -->
        <div class="detail-sidebar-right">
          <div class="detail-book-card">
            <div class="detail-book-card__top">
              <div class="detail-book-card__cover-wrapper">
                <img v-if="!loading" :src="bookInfo.cover" alt="Book Cover"
                  class="detail-book-card__cover" @click="startReading">
                <div v-else class="detail-book-card__cover--skeleton"></div>
              </div>

              <h1 class="detail-book-card__title">
                <template v-if="!loading">{{ bookInfo.title }}</template>
              </h1>
              <div class="detail-book-card__author">
                <template v-if="!loading">By {{ bookInfo.author }}</template>
              </div>

              <div class="detail-book-card__cta" @click="startReading">
                <span>Start Reading</span>
                <img src="@/assets/start-read-icon.svg" alt="Start"
                  class="detail-book-card__cta-icon">
              </div>
            </div>

            <div class="detail-book-card__separator"></div>

            <div class="detail-book-card__meta">
              <!-- Score -->
              <div class="detail-meta-item">
                <div class="detail-meta-item__icon-wrapper">
                  <img src="@/assets/default/detail-star.svg" alt="score"
                    class="detail-meta-item__icon">
                </div>
                <div class="detail-meta-item__info">
                  <span class="detail-meta-item__label">Score：</span>
                  <span class="detail-meta-item__value">{{ bookInfo.score }}</span>
                </div>
              </div>
              <!-- Category -->
              <div class="detail-meta-item">
                <div class="detail-meta-item__icon-wrapper">
                  <img src="@/assets/default/detail-category.svg" alt="category"
                    class="detail-meta-item__icon">
                </div>
                <div class="detail-meta-item__info">
                  <span class="detail-meta-item__label">Category：</span>
                  <span class="detail-meta-item__value">{{ bookInfo.category }}</span>
                </div>
              </div>
              <!-- Update -->
              <div class="detail-meta-item">
                <div class="detail-meta-item__icon-wrapper">
                  <img src="@/assets/default/detail-update.svg" alt="update"
                    class="detail-meta-item__icon">
                </div>
                <div class="detail-meta-item__info">
                  <span class="detail-meta-item__label">Update：</span>
                  <span class="detail-meta-item__value">{{ bookInfo.updateTime }}</span>
                </div>
              </div>
              <!-- Chapters -->
              <div class="detail-meta-item">
                <div class="detail-meta-item__icon-wrapper">
                  <img src="@/assets/default/detail-chapters.svg" alt="chapters"
                    class="detail-meta-item__icon">
                </div>
                <div class="detail-meta-item__info">
                  <span class="detail-meta-item__label">Chapters：</span>
                  <span class="detail-meta-item__value">{{ bookInfo.chapters }}</span>
                </div>
              </div>
              <!-- Views -->
              <div class="detail-meta-item">
                <div class="detail-meta-item__icon-wrapper">
                  <img src="@/assets/default/detail-views.svg" alt="views"
                    class="detail-meta-item__icon">
                </div>
                <div class="detail-meta-item__info">
                  <span class="detail-meta-item__label">Views：</span>
                  <span class="detail-meta-item__value">{{ bookInfo.views }}</span>
                </div>
              </div>
              <!-- Marked -->
              <div class="detail-meta-item">
                <div class="detail-meta-item__icon-wrapper">
                  <img src="@/assets/default/detail-marked.svg" alt="marked"
                    class="detail-meta-item__icon">
                </div>
                <div class="detail-meta-item__info">
                  <span class="detail-meta-item__label">Marked：</span>
                  <span class="detail-meta-item__value">{{ bookInfo.marked }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <AdComponent v-if="deviceType !== 'mobile'"
      v-show="$global.isObjectNotEmpty(adsensConfig) && adsensConfig?.detail_2" ref="ads-detail-2"
      class="pc_padding" :ads="adsensConfig?.detail_2" :showDebug="showDebug" />

    <!-- You may also like -->
    <div class="detail-recommendations">
      <div class="detail-recommendations__header">
        <div class="detail-recommendations__more" @click="goToAllCategories">
          <div class="detail-recommendations__more-text">More</div>
          <img src="@/assets/more-icon.svg" alt="More" class="detail-recommendations__more-icon">
        </div>
        <div class="detail-recommendations__title">You may also like</div>
      </div>
      <div v-if="loadingReleated" class="detail-recommendations__loading">
        <div class="loader"></div>
        <p>Loading...</p>
      </div>
      <template v-else-if="releatedBook && releatedBook.length > 0">
        <div class="detail-recommendations__list-container">
          <div class="detail-recommendations__list"
            :class="{'detail-recommendations__list--mobile': deviceType === 'mobile'}">
            <BookCard class="detail-recommendations__item"
              v-for="(book, index) in (deviceType === 'mobile' ? releatedBook.slice(0, 10) : releatedBook.slice(0, 10))"
              :key="book.id" :book="book" @click="goToBook(book)" />
          </div>
        </div>
      </template>
    </div>

  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js'
import adMixin from '@/mixin/adMixin.js'
import adTrackingMixin from '@/mixin/adTrackingMixin.js'
import AdComponent from '@/pages/components/AdComponent.vue'
import BookCard from '@/components/BookCard.vue'
import { mapGetters } from 'vuex'
import CommonPages from '@/pages/components/page_common.vue'

import '@/css/detail.scss'

export default {
  name: 'Detail',
  components: {
    CommonPages,
    AdComponent,
    BookCard
  },
  mixins: [common, adMixin, adTrackingMixin],
  props: {
    categories: {
      type: String,
      default: ''
    },
    novelId: {
      type: String,
      default: ''
    },
    id: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      loading: true,
      defaultCover: require('@/assets/book_default_1.jpg'),
      bookInfo: {
        title: '',
        author: '',
        category: '',
        score: '',
        updateTime: '',
        chapters: '',
        views: '',
        marked: '',
        rank: '',
        cover: '',
        summary: '',
        tags: [],
        chapterList: []
      },
      chapterPage: 1,
      chaptersPerPage: 20,
      releatedCurrentPage: 1,
      releatedPerPage: 6,
      releatedBook: [],
      loadingReleated: true,
      errorMessage: '',
      showCoverChapter: false,
      adConfig: {
        ins: {
          detail_2: 'detail_2',
        },
        releatedBook: 'releatedBook',
      }
    }
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
      'deviceType',
      'domainConfig',
    ]),
    displayedChapters () {
      const filteredChapters = this.showCoverChapter
        ? this.bookInfo.chapterList
        : this.bookInfo.chapterList.filter(chapter =>
          !(chapter.number === 0 || chapter.number === '0') ||
          !chapter.title.toLowerCase().includes('cover'));

      const start = (this.chapterPage - 1) * this.chaptersPerPage;
      const end = start + this.chaptersPerPage;
      return filteredChapters.slice(start, end);
    },
    chapterTotalPages () {
      const filteredLength = this.showCoverChapter
        ? this.bookInfo.chapterList.length
        : this.bookInfo.chapterList.filter(chapter =>
          !(chapter.number === 0 || chapter.number === '0') ||
          !chapter.title.toLowerCase().includes('cover')).length;

      return Math.ceil(filteredLength / this.chaptersPerPage);
    },
    paginatedReleatedBooks () {
      if (!this.releatedBook || this.releatedBook.length === 0) {
        return [];
      }
      const start = (this.releatedCurrentPage - 1) * this.releatedPerPage;
      const end = start + this.releatedPerPage;
      return this.releatedBook.slice(start, end);
    },
    totalReleatedPages () {
      if (!this.releatedBook || this.releatedBook.length === 0) {
        return 0;
      }
      return Math.ceil(this.releatedBook.length / this.releatedPerPage);
    }
  },
  async activated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Detail] Component activated, id: ${this.id}, categories: ${this.categories}, novelId: ${this.novelId}`)
    }
    this.fetchBookDetail();
  },
  async mounted () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Detail] Component mounted`)
    }
    await this.fetchBookDetail();
    // await this.initAdSystem();
    // this.$nextTick(() => {
    //   this.initAdTracking();
    // });
  },
  deactivated () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Detail] Component deactivated`)
    }
  },
  beforeDestroy () {
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Detail] Component beforeDestroy`)
    }
  },
  methods: {
    // 前往排行榜页面
    goToAllCategories () {
      // 重定向到"all"分类路由
      this.$router.push('/all');
    },
    async fetchBookDetail () {
      this.loading = true;
      if (!this.id) {
        this.errorMessage = 'Error code 3';
        this.loading = false;
        return;
      }
      try {
        const response = await this.$global.server.getNovalInfo({ id: this.id });
        if (response && response.code === 200 && response.data) {
          const data = response.data.novelInfo;
          this.bookInfo = {
            id: this.id,
            title: data.novelName,
            author: data.novelAuthorName,
            novelId: data.novelId,
            category: data.novelType,
            score: data.novelScoreStr,
            updateTime: data.createTime ? this.$global.formatDate(data.createTime, 'yyyy-MM-dd') : '',
            cover: data.bigImg,
            summary: data.novelStoryIntro,
            tags: data.novelTag ? data.novelTag.split(',').map(tag => tag.trim()) : [],
            views: data.viewCount || 0,
            marked: data.collectCount || 0,
            rank: data.rank || '',
            status: data.status || '',
            chapters: data.novelChapter ? data.novelChapter.length : 0
          };
          this.bookInfo.chapterList = this.formatChapterList(data.novelChapter || []);
          this.releatedBook = (response.data.novelList || []).map(v => ({
            id: v.id,
            title: v.novelName,
            author: v.novelAuthorName,
            coverImage: v.bigImg,
            category: v.novelType,
            rating: v.novelScoreStr,
            novelId: v.novelId
          }));
          this.loadingReleated = false
        } else {
          this.errorMessage = response?.msg || 'Error code 1';
        }
      } catch (error) {
        this.errorMessage = `Error code 2 ${error.message}`;
      }
      this.loading = false;
    },
    formatChapterList (chapters) {
      if (!chapters || !Array.isArray(chapters) || chapters.length === 0) {
        return [];
      }
      const formattedChapters = chapters.map((chapter, index) => {
        if (typeof chapter === 'string') {
          const match = chapter.match(/^(\d+)\.(.+)$/);
          if (match) {
            return { id: index, number: parseInt(match[1], 10), title: match[2].trim() };
          } else {
            return { id: index, number: index + 1, title: chapter };
          }
        } else if (typeof chapter === 'object' && chapter !== null) {
          return { id: chapter.id || index, number: chapter.number || index + 1, title: chapter.title || `Chapter ${index + 1}` };
        } else {
          return { id: index, number: index + 1, title: `Chapter ${index + 1}` };
        }
      });
      if (formattedChapters.some(c => (c.number === 0 || c.number === '0') && c.title.toLowerCase().includes('cover'))) {
        this.bookInfo.chapters = formattedChapters.length - 1;
      }
      return formattedChapters;
    },
    startReading () {
      const firstChapter = this.bookInfo.chapterList.find(c => c.number > 0) || { number: 1 }
      this.goToChapter(firstChapter);
    },
    navigateToTag (tag) {
      // Maybe navigate to categories page with tag as filter
    },
    goToChapter (chapter) {
      const formattedNovelName = this.novelId || this.bookInfo.title.toLowerCase().replace(/\s+/g, '-');
      const summaryId = this.bookInfo.id || this.id;
      this.$router.push(`/chapter/${formattedNovelName}/${summaryId}/${chapter.number}`);
    },
    goToBook (book) {
      const categoryParam = book.category.toLowerCase().replace(/\s+/g, '-');
      const titleParam = book.novelId ? book.novelId.toLowerCase().replace(/\s+/g, '-') :
        book.title.toLowerCase().replace(/\s+/g, '-');
      const idParam = book.id;
      if (this.$route.params.channel) {
        this.$router.push(`/${this.$route.params.channel}/${categoryParam}/${titleParam}/${idParam}`);
      } else {
        this.$router.push(`/${categoryParam}/${titleParam}/${idParam}`);
      }
    },
    prevChapterPage () {
      if (this.chapterPage > 1) this.chapterPage--;
    },
    nextChapterPage () {
      if (this.chapterPage < this.chapterTotalPages) this.chapterPage++;
    },
    goToChapterPage (page) {
      this.chapterPage = page;
    },
    toggleCoverChapter () {
      this.showCoverChapter = !this.showCoverChapter;
      this.chapterPage = 1;
    },
    nextReleatedPage () {
      if (this.releatedCurrentPage < this.totalReleatedPages) {
        this.releatedCurrentPage++;
      }
    },
    prevReleatedPage () {
      if (this.releatedCurrentPage > 1) {
        this.releatedCurrentPage--;
      }
    },
    goToReleatedPage (page) {
      this.releatedCurrentPage = page;
    }
  }
}
</script>

<style lang="scss">
.detail__chapters-cover-toggle {
	margin-left: 10px;
	font-size: 14px;
	display: inline-flex;
	align-items: center;
	input {
		margin-right: 5px;
	}
	span {
		font-size: 14px;
		color: #999;
	}
}
</style>
